// extracted by mini-css-extract-plugin
export default {"readmailCommentModal":"index-module--readmail-comment-modal---uVoB"};